import { render, staticRenderFns } from "./AccountTabBonusCharge.vue?vue&type=template&id=d58f031c"
import script from "./AccountTabBonusCharge.vue?vue&type=script&lang=js"
export * from "./AccountTabBonusCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports